import React, { useEffect, useState } from "react";
import { Database, AlertTriangle, CheckCircle2 } from "lucide-react";
import api from "../lib/api";

function relativeAgo(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const diffMs = Date.now() - d.getTime();
  if (diffMs < 60_000) return "just now";
  if (diffMs < 3_600_000) return `${Math.floor(diffMs / 60_000)} min ago`;
  if (diffMs < 86_400_000) return `${Math.floor(diffMs / 3_600_000)} hr ago`;
  if (diffMs < 7 * 86_400_000) return `${Math.floor(diffMs / 86_400_000)} d ago`;
  return d.toLocaleDateString();
}

export default function BackupStatusBadge() {
  const [status, setStatus] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/admin/backup-status")
      .then(({ data }) => {
        if (!cancelled) {
          setStatus(data);
          setLoaded(true);
        }
      })
      .catch(() => {
        if (!cancelled) setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!loaded) return null;

  if (!status?.configured) {
    return (
      <div
        data-testid="backup-status-badge"
        className="flex items-center gap-2 rounded-md border px-2.5 py-1 text-[11px]"
        style={{
          backgroundColor: "rgba(232, 203, 142, 0.10)",
          borderColor: "rgba(232, 203, 142, 0.45)",
          color: "#9A7A2A",
        }}
      >
        <AlertTriangle className="h-3.5 w-3.5" strokeWidth={1.8} />
        Backup not configured
      </div>
    );
  }

  const ok = !!status.success;
  return (
    <div
      data-testid="backup-status-badge"
      className="flex items-center gap-2 rounded-md border px-2.5 py-1 text-[11px]"
      style={{
        backgroundColor: ok ? "var(--success-bg)" : "var(--danger-bg)",
        borderColor: ok ? "var(--success-border)" : "var(--danger-border)",
        color: ok ? "var(--success-fg)" : "var(--danger-fg)",
      }}
      title={status.last_run}
    >
      {ok ? (
        <CheckCircle2 className="h-3.5 w-3.5" strokeWidth={1.8} />
      ) : (
        <AlertTriangle className="h-3.5 w-3.5" strokeWidth={1.8} />
      )}
      <span>
        Last backup: {relativeAgo(status.last_run)} {ok ? "✓" : "FAILED"}
      </span>
      {status.size_bytes ? (
        <span style={{ color: "var(--page-fg-muted)" }}>
          · {(status.size_bytes / 1024 / 1024).toFixed(1)} MB
        </span>
      ) : null}
    </div>
  );
}
